import { z } from 'zod';

export const loginSchema = z.object({
  email: z.string().email('유효한 이메일을 입력하세요.'),
  password: z.string().min(1, '비밀번호를 입력하세요.'),
});

export const ROLE_OPTIONS = [
  { value: 'PM', label: 'PM (프로젝트 매니저)' },
  { value: 'DEVELOPER', label: '개발자' },
  { value: 'QA', label: 'QA (테스터)' },
  { value: 'DESIGNER', label: '디자이너' },
  { value: 'VIEWER', label: '뷰어 (읽기 전용)' },
] as const;

export const registerSchema = z
  .object({
    name: z.string().min(1, '이름을 입력하세요.').max(50, '이름은 50자 이하여야 합니다.'),
    email: z.string().email('유효한 이메일을 입력하세요.'),
    password: z
      .string()
      .min(8, '비밀번호는 최소 8자 이상이어야 합니다.')
      .regex(/[A-Za-z]/, '영문자를 포함해야 합니다.')
      .regex(/[0-9]/, '숫자를 포함해야 합니다.'),
    passwordConfirm: z.string().min(1, '비밀번호 확인을 입력하세요.'),
    role: z.enum(['PM', 'DEVELOPER', 'QA', 'DESIGNER', 'VIEWER']),
  })
  .refine((data) => data.password === data.passwordConfirm, {
    message: '비밀번호가 일치하지 않습니다.',
    path: ['passwordConfirm'],
  });

export type LoginFormValues = z.infer<typeof loginSchema>;
export type RegisterFormValues = z.infer<typeof registerSchema>;
